import { render, staticRenderFns } from "./menuActions.vue?vue&type=template&id=3fe1e088&scoped=true"
import script from "./menuActions.vue?vue&type=script&lang=js"
export * from "./menuActions.vue?vue&type=script&lang=js"
import style0 from "./menuActions.vue?vue&type=style&index=0&id=3fe1e088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe1e088",
  null
  
)

export default component.exports